import * as React from 'react';


import _ from "lodash";
import { useState } from "react";
import { useLoc } from "../../../hooks/useLoc";
import firstCapitalCase from "../../../services/firstCapitalCase";
import isBrowser from "../../../services/isBrowser";
import { updateMeasuresFromSelector, checkStateValues } from "./service";
import { chartWidthBreakpoints as widthBreakpoints } from './service';
import { measureColors as colorMapping } from '../../../services/measureColors';


import Select from 'react-select';
import { WeatherData } from '../../../templates/fragments/weather-data';
import { Checkbox } from '../../shared/base/checkbox';
import { useElementSize } from '../../../hooks/useElementSize';
import { selectTheme, styles } from '../../../services/selectTheme';
export const ChartForm = ({ weatherData, shownMeasuresState, setShownMeasuresState, chartWidth, currentMeasures }: { weatherData: WeatherData, shownMeasuresState: { [key: string]: boolean }, setShownMeasuresState: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>, chartWidth: number, currentMeasures: string[] }) => {

    const [randomKey] = useState(Math.random().toString(36).replace(/[^a-z]+/g, '').substring(0, 5));
    const [measureSelectorValue, setMeasureSelectorValue] = useState('overview');
    const windowWidth = useElementSize({ defaultValue: 600 });
    const loc = useLoc();
    const measureSelectorRef = React.useRef(null);
    const measureOptions = currentMeasures
        .filter(m => _.some(weatherData[m], v => v != 0))
        .map(m => { return { value: m, label: `${firstCapitalCase(loc('common.measures.' + m))}` } })
    const measureSelectorValues = [{ value: 'overview', label: `${firstCapitalCase(loc('common.weatherOverview'))}` }, ...measureOptions];
    const allowMeasureSelection = windowWidth >= widthBreakpoints.globalWindowBreakpoint;
    if (allowMeasureSelection) measureSelectorValues.splice(1, 0, { value: 'detail', label: 'Weather detail' });
    //console.log(measureOptions)
    return (<form className="pl-4 md:pl-16 flex flex-wrap mdmax:justify-center md:grid md:grid-cols-4 gap-x-4 gap-y-2 md:gap-6 sm:my-1 md:my-3">
        {currentMeasures.map(measure => {
            if ((_.includes(['ws', 'sst', 'rhm', 'sunhrs'], measure)) && _.every(weatherData[measure], v => v == 0)) {
                return null;
            }
            if (!allowMeasureSelection && !shownMeasuresState[measure]) return null;
            return (
                <Checkbox
                    inputKey={`${randomKey}-${measure}Input`}
                    key={`${randomKey}-${measure}Input`}
                    clickable={allowMeasureSelection}
                    checked={shownMeasuresState[measure]}
                    color={colorMapping[measure]}
                    label={`${firstCapitalCase(loc('common.measures.' + measure))}`}
                    className="mr-4 font-b font-bold text-xs tracking-wide"
                    onChange={() => {
                        setShownMeasuresState(oldState => {
                            let newState = { ...oldState };
                            newState[measure] = !oldState[measure];
                            return newState;
                        })
                        setMeasureSelectorValue(null);
                        measureSelectorRef.current.clearValue();

                    }}
                />)
        })}
        {allowMeasureSelection && <div className="col-start-2 col-span-2">
            <Select
                ref={measureSelectorRef}
                isSearchable={false}
                className="max-w-[350px] m-auto"
                menuPortalTarget={isBrowser() ? document.body : null}
                styles={{ ...styles, menuPortal: (provided, props) => ({ ...styles.menuPortal(provided, props), zIndex: 9999 }) }}
                menuPlacement="top"
                theme={selectTheme}
                onChange={(opt) => {
                    setMeasureSelectorValue(opt?.value)
                    if (!opt?.value || !shownMeasuresState) return;
                    let newState = updateMeasuresFromSelector({ selectedValue: opt?.value, weatherData });
                    checkStateValues(newState, weatherData)
                    setShownMeasuresState(newState);
                }}
                value={measureSelectorValues.find(m => m.value == measureSelectorValue)}
                options={measureSelectorValues}
                name="name"
                placeholder="Custom selection"
            />
        </div>}
    </form>)

}